import ClickAndCollectCollectionPoint from './ClickAndCollectCollectionPoint';

export default ClickAndCollectCollectionPoint;
